import { render, staticRenderFns } from "./ClickToPay.vue?vue&type=template&id=3d2f5b84&scoped=true"
import script from "./ClickToPay.vue?vue&type=script&lang=js"
export * from "./ClickToPay.vue?vue&type=script&lang=js"
import style0 from "./ClickToPay.vue?vue&type=style&index=0&id=3d2f5b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f5b84",
  null
  
)

export default component.exports